
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useInvitationManagement } from '@/hooks/useInvitationManagement';
import { UserCheck, Loader2 } from 'lucide-react';

interface OrphanedUserFixButtonProps {
  email: string;
  invitationId: string;
  isUsed?: boolean;
}

const OrphanedUserFixButton: React.FC<OrphanedUserFixButtonProps> = ({ 
  email, 
  invitationId, 
  isUsed 
}) => {
  const [isFixing, setIsFixing] = useState(false);
  const { fixOrphanedUser } = useInvitationManagement();

  const handleFixOrphanedUser = async () => {
    console.log('🔧 [ORPHAN FIX] Starting fix for email:', email);
    setIsFixing(true);
    
    try {
      const success = await fixOrphanedUser(email);
      console.log('🔧 [ORPHAN FIX] Fix result:', success);
    } catch (error) {
      console.error('🔧 [ORPHAN FIX] Error during fix:', error);
    } finally {
      setIsFixing(false);
    }
  };

  // Don't show the button if invitation is already used
  if (isUsed) {
    return null;
  }

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleFixOrphanedUser}
      disabled={isFixing}
      className="flex items-center gap-1 text-xs"
    >
      {isFixing ? (
        <Loader2 className="h-3 w-3 animate-spin" />
      ) : (
        <UserCheck className="h-3 w-3" />
      )}
      {isFixing ? 'Fixing...' : 'Fix User'}
    </Button>
  );
};

export default OrphanedUserFixButton;
